// extracted by mini-css-extract-plugin
export default {"not_found":"NotFound_not_found__8laJi","box":"NotFound_box__R6GyI"};